import { createContext, ReactNode, useContext } from "react";
import { AuthStoreInterface } from "../model/auth.types";
import { useAuthStore } from "../lib/auth.store";

const AuthContext = createContext<AuthStoreInterface | null>(null)

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const store = useAuthStore();
  return(
    <AuthContext.Provider value={store}>
      {children}
    </AuthContext.Provider>
  )
}

const useAuthContext = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthContext must be used within AuthProvider");
  return ctx
}

export { AuthProvider, useAuthContext };